import { Component, ElementRef, EventEmitter, OnDestroy, Output, QueryList, ViewChildren } from '@angular/core';

import { Subscription } from 'rxjs';

import { MonitorConfigService } from '../../../../Common/MonitorShared/services/monitor-config.service';
import { LeftSidebarListItem } from '../../../../Common/Layout/models/left-sidebar-list-item.model';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';

@Component({
    selector: 'agpr-monitoring-account-preferences',
    templateUrl: './monitoring-account-preferences.component.html',
    styleUrls: ['./monitoring-account-preferences.component.scss'],
    standalone: false
})
export class MonitoringAccountPreferencesComponent implements OnDestroy {

    @Output() sectionListItems = new EventEmitter<LeftSidebarListItem[]>();

    @ViewChildren('section') set sections(list: QueryList<ElementRef>) {
        if (list) {
            this.sectionListItems.emit(
                list.toArray().map(item => {
                    return {
                        label: `AccountPreferences.${item.nativeElement.id}`,
                        value: item
                    } as LeftSidebarListItem;
                })
            );
        }
    };

    hasFinancialTimesEnabled: boolean = false;
    loaded: boolean = false;

    readonly messageSeverityEnum = messageSeverityEnum;

    private subscriptions: Subscription[] = [];

    constructor(
        private monitorConfigService: MonitorConfigService
    ) {
        this.subscriptions.push(
            this.monitorConfigService.getFinancialTimesEnabled().subscribe(hasFTEnabled => {
                this.hasFinancialTimesEnabled = hasFTEnabled;
                this.loaded = true;
            })
        );
    }

    // True if any section below has something to show. OR in additional flags here as more sections
    // (e.g. API Keys, Data Connections, Styles, Templates) are added to this page.
    get hasAccountPreferences(): boolean {
        return this.hasFinancialTimesEnabled;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
